module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.ttf
// module id = 375
// module chunks = 0